module.exports = __webpack_public_path__ + "static/media/sms-icon-inactive.0be88de4.svg";